import * as React from 'react';
import { useSelector } from 'react-redux';

import { SeoMarkedList } from '../../components/SeoMarkedList';
import { getMarkedListItems } from '../../selectors/seo';

export const SeoMarkedListContainer: React.FC = () => {
  const markedListItems = useSelector(getMarkedListItems);

  if (markedListItems.length === 0) {
    return null;
  }

  return <SeoMarkedList items={markedListItems} />;
};
